// TOM-673: a sensor still reports when its alarm is switched off. Resolve that
// display-only source with the shared compiler, without changing the armed
// ruleset projection or deriving a second set of recipe binding rules.
import { alertDefinitionSchema, compileDefinitions } from '@neomaris/rules';

import type { AlarmDefView } from './alarmDisplay';
import type { ValueLineDef } from './alarmLive';

export function alarmDataSource(def: AlarmDefView, catalog: ReadonlySet<string>): ValueLineDef {
  if (def.enabled) return def;

  const parsed = alertDefinitionSchema.safeParse({
    ...def,
    enabled: true,
    severity: def.severity ?? 'alarm',
    sourcePaths: [],
    deviceIds: [],
    custom: def.custom ?? undefined,
    binding: def.binding ?? undefined,
    // Qualifiers govern evaluation, not which sensor supplies this reading.
    conditions: undefined,
    notificationUrgencyByMode: {},
    origin: 'cloud',
    updatedAt: '',
  });
  const rule = parsed.success ? compileDefinitions([parsed.data], catalog).rules[0] : undefined;
  return {
    recipeId: def.recipeId,
    custom: def.custom,
    resolvedPath: rule?.inputPath ?? null,
    trigger:
      rule === undefined
        ? null
        : {
            ...rule.trigger,
            class: rule.class,
            ...(rule.class === 'AnchorWatch' ? { setpoint: rule.trigger.triggerRadius } : {}),
          },
  };
}
